<form *dynamicFormInfo="formInfo" (keyup.enter)="search()">
  <div class="row">
    <div class="col-5">
      <app-text-input
        controlName="tpaNumber"
        hint="TPA ID must be formatted as 'T' followed by six digits."
        tooltipText="Required format: T000000"
      ></app-text-input>
    </div>
    <div class="col-2">
      <app-select-input
        #nameSearchOptionTypeList
        controlName="nameSearchOptionType"
        [showNullPlaceholder]="false"
      ></app-select-input>
    </div>
    <div class="col-5">
      <app-generic-input
        approvedNameCharacters
        controlName="thirdPartyAdministratorName"
      ></app-generic-input>
    </div>
  </div>
  <div class="row">
    <div class="col-5">
      <app-text-input
        #feinTemplate
        controlName="fein"
        [maskConfig]="feinMaskConfig"
        hint="FEIN must be nine digits."
        (input)="onFeinChange()"
        tooltipText="Required format: 00-0000000"
      ></app-text-input>
    </div>
  </div>
</form>
